// Saikrishna 27/10/2022 3075234474 Scheduling functionality (Reccurence Pattern- monthly(newly added total functionality)
// Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
// akhila 03/11/2022 3075234474 get api integration and data prepopulation
// Raghu 09/11/2022 3075234474 Helper Text & UI alignment changes
// akhila  11/11/2022 3075234474 fixed validations issues
// Prakash  11/11/2022 3075234474 fixed validations Alignments issues.
// akhila  12/11/2022 30752344 fixed form reset and validation issues.
// akhila 11/11/2022 3075234474 added new UI Fields for Reports
// Prakash 04/07/2023 3075234474 fixed radio button color.
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import React from 'react';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import reusableInputStyles from '../../../../../components/InputStyles';

const MonthlySchedule = ({
  values,
  setFieldValue,
  handleChange,
  touched,
  errors,
  handleBlur,
  WeekNoOptions,
  WeekDayNameOptions,
}) => {
  const classes = reusableInputStyles();
  return (
    <>
      <div className={classes.globalTextFields}>
        <FormControl component="fieldset" className={classes.checkBox}>
          <RadioGroup
            aria-label="monthly"
            name="monthly"
            value={values.monthly}
            onChange={handleChange}
          >
            <div className="d-flex align-items-center form-group">
              <FormControlLabel
                value="day"
                control={<Radio />}
                label="Day"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue('monthlyFrequencyNo', '');
                  setFieldValue('monthlyWeekDayName', '');
                  setFieldValue('monthlyWeekNo', '');
                }}
              />
              <div>
                <TextField
                  margin="dense"
                  className={classes.textComponent}
                  variant="outlined"
                  placeholder={``}
                  disabled={values.monthly !== 'day'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // InputProps={{
                  //     endAdornment: (
                  //         <InputAdornment position="end">
                  //             <span style={{ color: "black" }}>day(s)</span>
                  //         </InputAdornment>
                  //     ),
                  // }}
                  name="monthlyDay"
                  value={values?.monthlyDay?.toUpperCase()}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  // error={Boolean(touched?.monthlyDay && errors?.monthlyDay)}
                  onBlur={handleBlur}
                  // fullWidth
                />
                <FormHelperText margin="dense">
                  {touched.monthlyDay && errors.monthlyDay && errors.monthlyDay}
                </FormHelperText>
              </div>
              <FormLabel className={`mx-2 ${classes.formLabel}`}>of every</FormLabel>
              <div>
                <TextField
                  className={classes.textComponent}
                  margin="dense"
                  variant="outlined"
                  placeholder={``}
                  disabled={values.monthly !== 'day'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // InputProps={{
                  //     endAdornment: (
                  //         <InputAdornment position="end">
                  //             <span style={{ color: "black" }}>day(s)</span>
                  //         </InputAdornment>
                  //     ),
                  // }}
                  name="monthlyMonth"
                  value={values?.monthlyMonth?.toUpperCase()}
                  onChange={handleChange}
                  // error={Boolean(touched?.monthlyMonth && errors?.monthlyMonth)}
                  onBlur={handleBlur}
                  // fullWidth
                />
                <FormHelperText margin="dense">
                  {touched.monthlyMonth && errors.monthlyMonth && errors.monthlyMonth}
                </FormHelperText>
              </div>
              <FormLabel className={`ml-2 ${classes.formLabel}`}>month(s)</FormLabel>
            </div>
            <div className="d-flex align-items-center form-group">
              <FormControlLabel
                value="weekDay"
                control={<Radio />}
                label="The"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue('monthlyDay', '');
                  setFieldValue('monthlyMonth', '');
                }}
              />
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  className={`mr-1`}
                  name="monthlyWeekNo"
                  size="small"
                  options={WeekNoOptions}
                  // fullWidth
                  // className="select-gender"
                  label="Type"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.monthlyWeekNo || 'none'}
                  onBlur={handleBlur}
                  disabled={values.monthly !== 'weekDay'}
                  touched={touched.monthlyWeekNo}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('monthlyWeekNo', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // error={Boolean(touched.monthlyWeekNo && errors.monthlyWeekNo)}
                      // required
                      // label="Monthly Week No"
                      name="monthlyWeekNo"
                      variant="standard"
                      margin="dense"
                      placeholder="Select monthly week no"
                    />
                  )}
                />
                <FormHelperText margin="dense">
                  {touched.monthlyWeekNo && errors.monthlyWeekNo && errors.monthlyWeekNo}
                </FormHelperText>
              </div>
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  className={`ml-1`}
                  name="monthlyWeekDayName"
                  size="small"
                  options={WeekDayNameOptions}
                  // fullWidth
                  // className="select-gender"
                  label="Week Day"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.monthlyWeekDayName || 'none'}
                  onBlur={handleBlur}
                  disabled={values.monthly !== 'weekDay'}
                  touched={touched.monthlyWeekDayName}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('monthlyWeekDayName', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      error={Boolean(touched.type && errors.type)}
                      // required
                      // label="Week Day"
                      name="monthlyWeekDayName"
                      variant="standard"
                      margin="dense"
                      placeholder="Select monthly week Day"
                    />
                  )}
                />
                <FormHelperText margin="dense">
                  {touched.monthlyWeekDayName &&
                    errors.monthlyWeekDayName &&
                    errors.monthlyWeekDayName}
                </FormHelperText>
              </div>
              <FormLabel className={`mx-2 ${classes.formLabel}`}>of every</FormLabel>
              <div>
                <TextField
                  className={`mx-2 ${classes.textComponent}`}
                  margin="dense"
                  variant="outlined"
                  placeholder={``}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  name="monthlyFrequencyNo"
                  disabled={values.monthly !== 'weekDay'}
                  value={values?.monthlyFrequencyNo?.toUpperCase()}
                  onChange={handleChange}
                  // error={Boolean(touched?.monthlyFrequencyNo && errors?.monthlyFrequencyNo)}
                  onBlur={handleBlur}
                />
                {values?.monthlyFrequencyNo ? (
                  ''
                ) : (
                  <FormHelperText margin="dense">
                    {touched.monthlyFrequencyNo &&
                      errors.monthlyFrequencyNo &&
                      errors.monthlyFrequencyNo}
                  </FormHelperText>
                )}
              </div>
              <FormLabel className={`mx-2 ${classes.formLabel}`}>month(s)</FormLabel>
            </div>
            <div className="d-flex align-items-center form-group">
              <FormControlLabel
                value="lastDayOfMonth"
                control={<Radio />}
                label="Last day of month"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue('monthlyDay', '');
                  setFieldValue('monthlyMonth', '');
                  setFieldValue('monthlyFrequencyNo', '');
                  setFieldValue('monthlyWeekDayName', '');
                  setFieldValue('monthlyWeekNo', '');
                }}
              />
            </div>
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};

export default MonthlySchedule;
